<template lang="pug">
.page
  .page-header.container
    back-button

  post-single.container(
    :post="post"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import BackButton from '@/components/back-button'
import PostSingle from '@/components/post/post-single'

export default {
  name: 'single-post',
  components: {
    BackButton,
    PostSingle,
  },
  computed: {
    ...mapGetters(['getPost']),
    post() {
      return this.getPost(this.$route.params.id)
    },
  },
}
</script>


